import { useEffect, useRef } from "react";
import type { SocketHandler } from "./manager";
import { useSocket } from "./provider";

/**
 * Declarative subscription to a server event:
 *
 *   useSocketEvent("order_status_changed", (order) => refetch());
 *
 * The handler may be an inline closure — the latest render's version is always
 * the one invoked, without resubscribing on every render.
 */
export function useSocketEvent(event: string, handler: SocketHandler): void {
  const { on } = useSocket();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    return on(event, (...args) => handlerRef.current(...args));
  }, [event, on]);
}
